import { useState } from 'react';
import "../style/suspension/suspension.css"

function Suspension(){

    const [appealClicked, setAppealClicked] = useState(false)
    const [reason, setReason] = useState("")
    const [isSubmitted, setSubmitted] = useState(false)

    function toggleAppeal(){
        setAppealClicked(prevState => !prevState)
    }

    function handleChange(event){
        setReason(event.target.value)
    }

    function submitAppeal(){
        fetch("http://localhost:3000/support/contact-us", {
            method: "POST",
            headers: {
                "content-type": "application/json"
            },
            body: JSON.stringify({
                "A user has submmitted an appeal to their suspension, they have stated that": reason
            })
        })
        .then((response) => {
            if (response.ok) {
                alert("Your appeal has been sent and we will review your account.")
                setSubmitted(true)
            }
            return response.json()
        })
        .then((result) => console.log(result))
        
    }

    return(
        <div className="container">
            <h1 className="pagename-s">My Profile</h1>
            {isSubmitted ? (
                <div className="suspend-container">
                    <h2>Your account is currently under review</h2>
                    <p>It will take a couple of days to review your account</p>
                    <p>Until then, your account will not be visible to other users</p>
                    <h2>What happens next?</h2>
                    <p>If the activity on your account does not break our guidelines, your account will be reactivated</p>
                    <p>If the activity on your account does break our guidelines, your account will be permenantly deleted</p>
                    <p>You will be sent an email regarding our decision</p>
                </div>
            ) : (
                <div className="suspend-container">
                    <h2>Unfortunately, your account is suspended</h2>
                    <p>Your account was reported and we found that the activity on it does not follow our guidelines.</p>
                    <h2>You have 14 days to appeal this decision</h2>
                    <p>If you think we suspended your account by mistake, click the appeal button to challenge this decision.</p>
                    <p>You must appeal the decision within 14 days after your account was suspended. After 14 days, your account will be permanently disabled.</p>
                    <button onClick={toggleAppeal}>Appeal</button>
                    {appealClicked &&
                        <div className="appeal-form">
                            <h2>Why should your account be reinstated?</h2>
                            <textarea value={reason} onChange={handleChange} placeholder="Type reason here" />
                            <button onClick={submitAppeal}>Submit</button>
                        </div>
                        }
                </div>
            )}
        </div>
    );
}

export default Suspension;